import cx from 'classnames';
import { WASHMEN_DEFAULT_ADDRESS_TYPES } from 'packages/shared/newOrder/constants';
import * as React from 'react';
import { Col, Form, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export interface IAddressTypeRowProps {
  control: Control<any>;
}

const StyledToggleButton = styled(ToggleButton)`
  background: #fff;
  font-weight: 500;
  border: 1px solid #f2f3f8;
  color: ${({ theme }) => theme.colors.deepPurple};
  width: 40%;
  height: 133px;

  border-radius: 8px;
  margin: 6px;
  display: block;
  padding-top: 11px;

  &.selected,
  &.btn-secondary:not(:disabled):not(.disabled).active,
  &.show > .btn-secondary.dropdown-toggle {
    background: ${({ theme }) => theme.colors?.pastelLime} !important;
    border: ${({ theme }) => `1px solid ${theme.colors?.deepPurple}`} !important;
    color: ${({ theme }) => theme.text?.success} !important;
    font-weight: 500;
    box-shadow: none; /* Remove box shadow */
  }
`;

const StyledToggleButtonGroup = styled(ToggleButtonGroup)`
  display: flex;
  flex-wrap: wrap;
`;

const AddressTypeRow = ({ control }: IAddressTypeRowProps) => {
  const { t } = useTranslation();

  return (
    <Controller
      name="addressType"
      control={control}
      render={({ onChange, value }) => (
        <Col xs={12}>
          <Form.Group>
            <StyledToggleButtonGroup type="radio" name="addressType" onChange={onChange} value={value}>
              {WASHMEN_DEFAULT_ADDRESS_TYPES.map((address) => (
                <StyledToggleButton
                  style={{ borderRadius: '8px', margin: '6px' }}
                  key={address.id}
                  variant={value === address.id ? 'secondary' : 'light'}
                  className={cx('px-4 border', { selected: value === address.id })}
                  value={address.id}
                  onChange={() => onChange(address.id)}
                >
                  <div className="mb-2 h-25">{t(`common.addressTypes.${address.id}`)}</div>
                  <div>
                    <address.Icon />
                  </div>
                </StyledToggleButton>
              ))}
            </StyledToggleButtonGroup>
          </Form.Group>
        </Col>
      )}
    />
  );
};

export default AddressTypeRow;
